export default __webpack_public_path__ + "static/media/warning-icon.a636f05c.svg";